// TODO: If this experiment wins, we would add these styles in properly as variants (We'd need to create 6 new variants for the radio buttons alone).
// This was the quickest way by just appending a style tag within the <head> tag of the DOM for the purpose of rolling out a quick test.
const customCSS = `
    [data-testid="continue-button-center"] svg path {
        fill: #333 !important;
    }
    [data-testid="continue-button-centered"] {
        background-color: #FFED00 !important;
        color: #333 !important;
    }
    [data-testid="continue-button-centered"] svg path {
        fill: #333 !important;
    }
    [data-testid="continue-button-centered"]:disabled {
        background-color: rgb(214, 214, 214) !important;
        color: #333 !important;
    }
    [data-testid="continue-button-centered"] svg path {
        fill: #333 !important;
    }
    #centered-submit-button svg path {
        fill: #333 !important;
    }
    #centered-submit-button {
        background-color: #FFED00 !important;
        color: #333 !important;
    }
    #centered-submit-button svg path {
        fill: #333 !important;
    }
    #centered-submit-button:disabled {
        background-color: rgb(214, 214, 214) !important;
        color: #333 !important;
    }
    #centered-submit-button svg path {
        fill: #333 !important;
    }
    [data-testid="find-address-button"]:not(:disabled) {
        background-color: #FFED0020 !important;
        color: #333 !important;
        border-color: #333 !important;
    }
    [data-testid="find-address-button"]:not(:disabled) svg path {
        fill: #333 !important;
    }
    input[type="checkbox"]:checked {
        background-color: #FFED0020 !important;
        border-color: #333 !important;
    }
    input[type="checkbox"]:checked:after {
        content: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS40Mzk5IDAuNzI1ODhDMTUuNzc1NCAwLjk2ODgyIDE1Ljg1MDQgMS40Mzc3MyAxNS42MDc1IDEuNzczMjJMNS40ODM0MyAxNS43NTRMMC41MjIzMTcgMTEuNjU1MUMwLjIwMjk5NCAxMS4zOTEzIDAuMTU4MDA2IDEwLjkxODUgMC40MjE4MzQgMTAuNTk5MkMwLjY4NTY2MyAxMC4yNzk5IDEuMTU4NCAxMC4yMzQ5IDEuNDc3NzIgMTAuNDk4N0w1LjIwNjI2IDEzLjU3OTNMMTQuMzkyNiAwLjg5MzQ1NEMxNC42MzU1IDAuNTU3OTY1IDE1LjEwNDQgMC40ODI5NCAxNS40Mzk5IDAuNzI1ODhaIiBmaWxsPSJibGFjayIvPjwvc3ZnPg==) !important;
    }
    input[type="checkbox"]:hover {
        border-color: #333 !important;
    }
    .experimentalDoubleColumnSmall:hover,
    .experimentalDoubleColumnSmallHorizontal:hover {
        background-color: #FFED0020 !important;
    }
    input[type="radio"]:focus + .experimentalDoubleColumnSmall,
    input[type="radio"]:focus + .experimentalDoubleColumnSmallHorizontal {
        color: #333 !important;
        background-color: #FFED0020 !important;
        border-color: #333 !important;
    }
    input[type="radio"]:checked + .experimentalDoubleColumnSmall,
    input[type="radio"]:checked + .experimentalDoubleColumnSmallHorizontal {
        color: #333 !important;
        background-color: #FFED0020 !important;
        border-color: #333 !important;
    }
    
    .MuiFormLabel-root:not(.Mui-disabled, .Mui-error).Mui-focused{
        color: #333 !important;
    }
    .MuiFormControl-root:not(.Mui-disabled):hover .MuiFormLabel-root {
        color: rgb(51, 51, 51);
    }
    .MuiFilledInput-root {
        background-color: rgba(209, 209, 209,0.3) !important;
    }
    .MuiFilledInput-root.Mui-focused {
        background-color: #FFED0020 !important;
    }
    
    .MuiFilledInput-root:hover {
        background-color: #FFED0010 !important;
    }
    .MuiFilledInput-root::after {
        border-bottom: 2px solid #000 !important;
    }
    .progress-bar {
        background-color: rgba(0, 3, 51, 0.13) !important;
    }
    .progress-bar-percentage {
        box-shadow: rgb(68 68 68 / 20%) -2px 2px 5px 0px !important;
        background-color: rgb(255, 237, 0) !important;
    }
`

export default customCSS 
